// Context/AuthContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import usePostRequest from '../Hooks/usePostRequest';

const AuthContext = createContext();


export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const { post } = usePostRequest();

    useEffect(() => {
        const storedUser = sessionStorage.getItem('loggedInUser');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    const login = async (email, password) => {
        const payload = { email, password };
        const response = await post('/login', payload);
        if (response?.token && response?.user) {
            setUser(response.user);
            sessionStorage.setItem('loggedInUser', JSON.stringify(response.user));
            sessionStorage.setItem('authToken', response.token);
            return true;
        }
        return false;
    };

    const Register = async (name, username, email, password, confirm_password, role) => {
        const payload = { name, username, email, password, confirm_password, role };
        const response = await post('/register', payload);
        if (response?.user || response?.success) {
            return true;
        }
        return response;
    };

    const ForgetPassword = async (email) => {
        const payload = { email, };
        const response = await post('/forgot-password', payload);
        if (response?.message?.toLowerCase().includes('mail')) {
            return true;
        }
        return response;
    };
    const ResetPassword = async (email, password, password_confirmation, token) => {
        const payload = { email, password, password_confirmation, token };
        const response = await post('/reset-password', payload);

        if (response?.message?.toLowerCase().includes('reset')) {
            return true;
        }
        return response;
    };
    const ChangePassword = async (currentPassword, password, confirmPassword, authToken) => {
        const payload = {
            current_password: currentPassword,
            password: password,
            confirm_password: confirmPassword,
        };

        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };

        const response = await post('/change-password', payload, config);

        if (response?.message?.toLowerCase().includes('successfully')) {
            return true;
        }
        return response;
    };

    const logout = async () => {
        setUser(null);
        sessionStorage.removeItem('loggedInUser');
        const token = sessionStorage.getItem('authToken');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await post('/logout', config);
        sessionStorage.removeItem('authToken');

        return response;

    };

    return (
        <AuthContext.Provider value={{ user, login, logout, Register, ForgetPassword, ResetPassword, ChangePassword }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
